import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { pick } from "lodash";

const LoginDialog = ({ }) => {
  const { t } = useTranslation();
  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const setLoginModalShow = useContextSelector(
    AuthContext,
    (ctx) => ctx.setLoginModalShow,
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  const loginUser = async (body) => {
    setLoading(true);

    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    body.website = hostname || "winx9";

    const { status, data } = await apiPost(
      apiPath.loginUser,
      pick(body, ["username", "password", "uniqueId", "website"]),
    );

    if (data?.success) {
      localStorage.setItem("chatId", data.results.platformType);
      localStorage.setItem("token", data.results.token);
      localStorage.setItem("refresh_token", data.results.refresh_token);
      setUser(jwt_decode(data.results.token));
      setLoginModalShow(false);
      navigate("/");
    } else {
      toast.error(data?.message);
    }
    setLoading(false);
  };

  const onSubmit = (data) => {
    loginUser(data);
  };


  return (
    <div
      role="document"
      data-v-9cead1be=""
      className="v-dialog__content v-dialog__content--active"
      style={{ zIndex: 202 }}
      tabIndex={0}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent"
        style={{ transformOrigin: "center center", maxWidth: "400px" }}
      >
        <div
          data-v-9cead1be=""
          className="dialog-card v-card v-sheet theme--light"
        >
          <div
            data-v-9cead1be=""
            className="row no-gutters justify-space-between dialog-header"
          >
            <div
              data-v-9cead1be=""
              className="d-flex flex-column pl-6 py-4 col col-10"
            >
              <label
                data-v-9cead1be=""
                className="dialog-title text-capitalize d-block full-width white--text"
              >
                {t("WelcomeTowinx9")}
              </label>
            </div>
            <div
              data-v-9cead1be=""
              className="d-flex justify-content-center align-content-center col col-2"
            >
              <button
                data-v-9cead1be=""
                type="button"
                onClick={() => setLoginModalShow(false)}
                className="v-icon notranslate full-width v-icon--link mdi mdi-close theme--light white--text dialog-close-icon login"
              />
            </div>
          </div>

          <div data-v-9cead1be="" className="row dialog-row no-gutters pa-0">
            <div className="row no-gutters">
              <div className="col col-12 login_panel px-3">
                <form
                  noValidate
                  className="v-form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {/* ---- Username ---- */}
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block"
                          style={{ float: "left" }}
                        >
                          {t("Username")}<span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2" />
                      <div className="col col-12">
                        <div
                          className={
                            "v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder" +
                            (errors.username
                              ? " v-input--has-state error--text"
                              : "")
                          }
                        >
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <div className="v-input__prepend-inner">
                                <div className="v-input__icon v-input__icon--prepend-inner">
                                  <i
                                    aria-hidden="true"
                                    className={
                                      "v-icon notranslate material-icons theme--light" +
                                      (errors.username ? " error--text" : "")
                                    }
                                  >
                                    person_outline
                                  </i>
                                </div>
                              </div>
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  autoComplete="new-password"
                                  placeholder={t("FillUpHere")}
                                  type="text"
                                  {...register("username", {
                                    required: t("Enter_Username"),
                                  })}
                                />
                              </div>
                            </div>
                            <div className="v-text-field__details">
                              <div
                                className="v-messages theme--light error--text"
                                role="alert"
                              >
                                <div className="v-messages__wrapper">
                                  {errors.username && (
                                    <div className="v-messages__message">
                                      {errors.username.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ---- Password ---- */}
                  <div className="mobile">
                    <div className="row no-gutters justify-space-between">
                      <div className="col col-10">
                        <label
                          className="input-field-label ma-0 text-capitalize d-block"
                          style={{ float: "left" }}
                        >
                          {t("Password")}<span className="red--text ml-1">*</span>
                        </label>
                      </div>
                      <div className="col col-2" />
                      <div className="col col-12">
                        <div
                          className={
                            "v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder" +
                            (errors.password
                              ? " v-input--has-state error--text"
                              : "")
                          }
                        >
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <div className="v-input__prepend-inner">
                                <div className="v-input__icon v-input__icon--prepend-inner">
                                  <i
                                    aria-hidden="true"
                                    className={
                                      "v-icon notranslate material-icons theme--light" +
                                      (errors.password ? " error--text" : "")
                                    }
                                  >
                                    lock_outline
                                  </i>
                                </div>
                              </div>
                              <fieldset aria-hidden="true">
                                <legend style={{ width: "0px" }}>
                                  <span className="notranslate">​</span>
                                </legend>
                              </fieldset>
                              <div className="v-text-field__slot">
                                <input
                                  autoComplete="new-password"
                                  placeholder={t("FillUpHere")}
                                  type="password"
                                  {...register("password", {
                                    required: t("Enter_Password"),
                                    minLength: {
                                      value: 6,
                                      message: t("PasswordMin"),
                                    },
                                    maxLength: {
                                      value: 20,
                                      message: t("PasswordMax"),
                                    },
                                  })}
                                />
                              </div>
                            </div>
                            <div className="v-text-field__details">
                              <div
                                className="v-messages theme--light error--text"
                                role="alert"
                              >
                                <div className="v-messages__wrapper">
                                  {errors.password && (
                                    <div className="v-messages__message">
                                      {errors.password.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row no-gutters">
                    <div className="text-right forgot-password col col-12">
                      <button
                        type="button"
                        // onClick={() => navigate("/forgot-password")}
                        className="text-capitalize pr-0 v-btn v-btn--text theme--light v-size--default"
                        style={{ height: "auto" }}
                      >
                        <span className="v-btn__content">Forgot password?</span>
                      </button>
                    </div>
                  </div>

                  {/* ---- Submit ---- */}
                  <div className="row no-gutters">
                    <div className="col col-12">
                      <button
                        type="submit"
                        disabled={loading}
                        className="button-primary full-width font-weight-bold v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                        style={{ height: "auto" }}
                      >
                        <span className="v-btn__content">
                          {loading ? t("LoggingIn") : t("Login")}
                        </span>
                      </button>
                    </div>
                    <div className="text-center col col-12">
                      <label
                        className="red--text subtitle-2"
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                </form>

                <p className="mt-5 text-left subtitle-2">
                  {t("Donothaveanaccount")}{" "}
                  <a
                    className="link-underscore"
                    onClick={() => navigate("/register")}
                  >
                    {t("Singup")}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginDialog;
